const ARTWORK_ARG_RANGE = {
  percent: [0, 150],
  px: [1, 100],
  angle: [-180, 180],
};

export { ARTWORK_ARG_RANGE };
